// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "af3f3d1d","122": "21a578a4","354": "9c6094ad","535": "f969308e","697": "f26ebef8","728": "1ea937a6","783": "4e3ebad4",}[chunkId] + ".js"
}